import React from 'react';
import { ShieldCheck, Lock, Zap, UserCheck, HeadphonesIcon } from 'lucide-react';
export const TrustBar: React.FC = () => {
  const items = [{
    icon: <Lock className="w-5 h-5" data-id="element-327" />,
    text: 'Pago Seguro'
  }, {
    icon: <ShieldCheck className="w-5 h-5" data-id="element-328" />,
    text: 'Garantía 100%'
  }, {
    icon: <Zap className="w-5 h-5" data-id="element-329" />,
    text: 'Acceso Inmediato'
  }, {
    icon: <UserCheck className="w-5 h-5" data-id="element-330" />,
    text: 'Privacidad Protegida'
  }, {
    icon: <HeadphonesIcon className="w-5 h-5" data-id="element-331" />,
    text: 'Soporte Dedicado'
  }];
  return <div className="w-full bg-gray-50 border-y border-gray-200 py-6" data-id="element-332">
      <div className="max-w-6xl mx-auto px-4" data-id="element-333">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4" data-id="element-334">
          {items.map((item, index) => <div key={index} className="flex flex-col items-center justify-center text-center space-y-2" data-id="element-335">
              <div className="text-green-600 bg-green-100 p-3 rounded-full" data-id="element-336">
                {item.icon}
              </div>
              <span className="text-sm font-medium text-gray-700" data-id="element-337">
                {item.text}
              </span>
            </div>)}
        </div>
      </div>
    </div>;
};